import { getToken, notifyUnauthorized, resolveEngineAuthContext } from './auth';
import { PLUS_API_URL } from './env';

// Thin fetch wrapper for the Seitiate+ backend. Attaches JWT.

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

export async function apiFetch<T = unknown>(path: string, init: RequestInit = {}): Promise<T> {
  const token = getToken();
  // Forward the active tenant so the plus backend (P-4) can resolve which tenant
  // this request is for. It never blind-trusts the header — the engine validates
  // it against the user's real memberships — so this only *selects* among tenants
  // the user actually belongs to. Callers may override via init.headers.
  const { activeTenantId } = resolveEngineAuthContext();
  const response = await fetch(`${PLUS_API_URL}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(activeTenantId ? { 'X-Active-Tenant-ID': activeTenantId } : {}),
      ...(init.headers ?? {}),
    },
  });

  if (!response.ok) {
    const body = await response.text().catch(() => '');
    if (response.status === 401) {
      notifyUnauthorized(body || response.statusText || 'Session expired');
    }
    throw new ApiError(response.status, body || response.statusText);
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return (await response.json()) as T;
}
